import { request } from "utils/legacy_api";

export function index() {
  return request("/topics", { method: "GET" });
}

export function get(topicSlug) {
  return request(`/topics/${topicSlug}`, { method: "GET" });
}
